<template>
  <div class="date-content">
    <el-button v-if="showOutPreAndNext" size="mini" @click="dateChange(0)">
      <i class="el-icon-arrow-up"></i>
    </el-button>
    <el-time-picker
      :style="{width: setWidth+''}"
      v-model="time"
      v-time-format
      clearable
      :size="size"
      :format = "'HH:mm'"
      :readonly="readonly"
      :disabled="disabled"
      :clearable="clearable"
      :editable="editable"
      :placeholder="placeholder"
      :value-format="valueFormat"
      :default-value="defaultValue"
      @change="changeTime"
    ></el-time-picker>
    <el-button v-if="showOutPreAndNext" size="mini" @click="dateChange(1)">
      <i class="el-icon-arrow-down"></i>
    </el-button>
  </div>
</template>
<script>
  export default {
    props: {
      size: {
        type: String,
        default: 'mini'
      },
      readonly: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: true
      },
      editable: {
        type: Boolean,
        default: true
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      valueFormat: {
        type: String,
        default: ''
      },
      setWidth: {
        type: String,
        default: '100%'
      },
      showOutPreAndNext: {
        type: Boolean,
        default: false
      },
      defaultValue: {
        type: Date,
        default: () => {
          return new Date(new Date().setHours(8,0,0))
        }
      },
      vModel: null,
    },
    data() {
      return {
        time: '',
      };
    },
    watch: {
      vModel: {
        immediate: true,
        handler(val) {
          this.time = val
        }
      },
    },
    methods: {
      changeTime(val) {
        this.setTime(val)
        this.$emit('change', val)
      },
      dateChange(flag) {
        if (!this.time)return
        let date = this.time;if (flag == 1) {this.time = new Date(date.setHours(date.getHours() - 1));} else {this.time = new Date(date.setHours(date.getHours() + 1));}
        this.changeTime(this.time)
      },
      getArrayIndex(arr, obj) {
        var i = arr.length;while (i--) {if (arr[i] === obj) {return i;}}return -1;
      },
      setTime(val) {
        this.$emit("update:vModel", val)
      }
    }
  };
</script>

<style lang="scss" scoped>
  .date-content{width: 100%;}
</style>



// WEBPACK FOOTER //
// src/components/DateAndTime/timeSelect.vue